function GlobalHeaderPanelService($rootScope, $timeout) {
    this.panels = {
        none: 'none',
        login: 'login',
        signup: 'signup',
        loggedin: 'loggedin',
        resetpassword: 'resetpassword',
        trackmyorder: 'trackmyorder',
        browse: 'browse'
    };

    this._openPanel = this.panels.none;
    this._rootScope = $rootScope;
    this._timeout = $timeout;
}

GlobalHeaderPanelService.prototype.isOpen = function (panel) {
    return this._openPanel === panel;
};

GlobalHeaderPanelService.prototype.togglePanel = function (panel) {
    if (this._openPanel === panel) {
        this.closePanel(panel);
    } else {
        this.openPanel(panel);
    }

    return this._openPanel;
};

GlobalHeaderPanelService.prototype.openPanel = function (panel) {
    if (panel !== undefined && typeof panel === 'string') {
        this._openPanel = panel;
    }

    this._timeout(function () {
        this._rootScope.$broadcast('headerPanel:open', this._openPanel);
    }.bind(this));

    return this._openPanel;
};

GlobalHeaderPanelService.prototype.closePanel = function () {
    this._timeout(function (panel) {
        this._rootScope.$broadcast('headerPanel:close', panel);
    }.bind(this, this._openPanel));

    this._openPanel = this.panels.none;
};

GlobalHeaderPanelService.prototype.isClosed = function () {
    return this._openPanel === this.panels.none;
};

GlobalHeaderPanelService.prototype.isPanelNone = function () {
    return this._openPanel !== this.panels.none;
};

module.exports = GlobalHeaderPanelService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/global-header-panel-service.js
 **/